<template>
    <div class="store-tag-base">
      <router-view></router-view>
    </div>
  </template>

  <script>
  export default {
    name: "storeTagBase",
  };
  </script>
